import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Schedule} from '../../../../../models/schedule.model';

@Component({
  selector: 'app-confirmation-popup',
  templateUrl: './confirmation-popup.component.html',
  styleUrls: ['./confirmation-popup.component.css']
})
export class ConfirmationPopupComponent implements OnInit {
  massage: string;
  paramOne: string;
  paramSchedule: Schedule = null;

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/view-group/popups/confirmation-popup/confirmation-popup.component.ts